import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <p>Spend $40 for free UK Shipping</p>
      </div>
      <div className="header-main">
        <div className="header-logo">
          <Link to="/" onClick={toTop}>
            <img src="/brand-logo.svg" alt="pittleforestandco" />
          </Link>
        </div>
        <div className="header-icons">
          <Link to="/cartpage" className="icon-link" onClick={toTop}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
            </svg>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
      <nav className="header-nav">
        <Link to="/shop" onClick={toTop}>
          Shop
        </Link>
        <Link to="/about" onClick={toTop}>
          About Us
        </Link>
        <Link to="/contact" onClick={toTop}>
          Contact
        </Link>
        <div className="more-menu">
          <button
            type="button"
            className="more-toggle"
            aria-expanded={moreOpen}
            aria-controls="more-links"
            onClick={() => setMoreOpen((open) => !open)}
          >
            More
          </button>
          {moreOpen && (
            <div className="more-dropdown" id="more-links">
              <Link
                to="/privacy"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/cookies"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                Cookie Policy
              </Link>
              <Link
                to="/faqs"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                FAQs
              </Link>
              <Link
                to="/terms"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                Terms of Service
              </Link>
              <Link
                to="/shipping"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                Shipping
              </Link>
              <Link
                to="/returns"
                onClick={() => {
                  toTop();
                  setMoreOpen(false);
                }}
              >
                Returns
              </Link>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Header;
